import { render, staticRenderFns } from "./ExtraChargePaymentLinkWidget.vue?vue&type=template&id=026671fd&scoped=true&"
import script from "./ExtraChargePaymentLinkWidget.vue?vue&type=script&lang=ts&"
export * from "./ExtraChargePaymentLinkWidget.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraChargePaymentLinkWidget.vue?vue&type=style&index=0&id=026671fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026671fd",
  null
  
)

export default component.exports